import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

export interface AppDownloadBannerProps {
  url: string;
  onOpen: (event: MouseEvent<HTMLAnchorElement>) => void;
  onDismiss: () => void;
}

const MESSAGE_ID = 'app-download-banner-message';

// Space the layout reserves for the banner: h-12, none where the banner hides itself.
export const APP_BANNER_SPACE = '[--app-banner-height:48px] [@media(max-height:499px)]:[--app-banner-height:0px]';

const AppDownloadBanner = ({ url, onOpen, onDismiss }: AppDownloadBannerProps) => {
  const { t } = useTranslation();

  return (
    <div
      role="region"
      aria-labelledby={MESSAGE_ID}
      className="flex h-12 items-center gap-2 overflow-hidden bg-muted pl-4 pr-1 text-foreground [@media(max-height:499px)]:hidden"
    >
      <img src="/apple-touch-icon.png" alt="" className="hidden h-7 w-7 shrink-0 rounded-md min-[360px]:block" />
      <p id={MESSAGE_ID} className="line-clamp-2 min-w-0 flex-1 text-[13px] leading-4">
        {t('Install the GPS mobile app')}
      </p>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onOpen}
        className="flex h-9 shrink-0 items-center rounded-full bg-foreground px-4 text-[13px] font-semibold text-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground focus-visible:ring-offset-2 focus-visible:ring-offset-muted"
      >
        {t('Download')}
      </a>
      <button
        type="button"
        aria-label={t('Close')}
        onClick={onDismiss}
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full hover:bg-foreground/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-foreground"
      >
        <X className="h-5 w-5" aria-hidden="true" />
      </button>
    </div>
  );
};

export default AppDownloadBanner;
